import * as React from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  FunctionField,
  DateField,
} from 'react-admin'
import Typography from '@material-ui/core/Typography'
import { isRecurring, seriesLabel } from './recurringSeries'

const PostTitle = ({ record }) => {
  return <span>Event {record ? `"${record.name}"` : ''}</span>
}

// Herhaling en einddatum zijn alleen-lezen (ADR 0015): wijzigen loopt via
// "Reeks verlengen" op de detailpagina.
const SeriesHint = ({ record }) =>
  record && isRecurring(record.recurring) ? (
    <Typography variant="caption" color="textSecondary" component="p">
      Herhaling en einddatum zijn niet te wijzigen. Verleng de reeks via "Reeks
      verlengen" op de detailpagina.
    </Typography>
  ) : null

export const EventEdit = (props) => (
  <Edit title={<PostTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Naam" source="name" required />
      <TextInput multiline label="Beschrijving" source="description" required />
      <TextInput label="Prijs" source="cost" />
      <TextInput label="Fee" source="fee" disabled />
      <BooleanInput
        label="Alleen betalen met strippenkaart"
        source="creditcardOnly"
      />
      <DateInput label="Datum" source="startDate" required />
      <TextInput label="Starttijd" source="startTime" required />
      <TextInput label="Eindtijd" source="endTime" required />
      <FunctionField
        addLabel
        label="Terugkerende activiteit"
        render={seriesLabel}
      />
      <DateField addLabel label="Einddatum reeks" source="endDate" />
      <SeriesHint />
      <NumberInput
        label="Maximaal aantal deelnemers"
        source="maximumParticipants"
        required
      />
      <BooleanInput label="Prive" source="private" />
      <NumberInput label="Locatie" source="locationID" required />
      <NumberInput label="Organisator" source="ownerID" required />
      <NumberInput label="Activiteit" source="activity_type_id" required />
      <ReferenceInput
        label="Type"
        source="event_typeID"
        reference="event_type"
        required>
        <SelectInput optionText="name" optionValue="id" />
      </ReferenceInput>
      <NumberInput label="Groep" source="groupID" />
    </SimpleForm>
  </Edit>
)
